import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {
  APP_STORE_URL,
  PLAY_STORE_URL,
} from "src/app/constants/store-links.constants";
import {PlatformService} from "src/app/services/platform.service";
import {environment} from "src/environments/environment";

@Component({
  selector: "app-force-update",
  templateUrl: "./force-update.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class ForceUpdateComponent implements AfterViewInit, OnDestroy {
  @Input() public required = true;
  @Output() public readonly dismiss = new EventEmitter<void>();
  @ViewChild("dialog", {static: true})
  private readonly dialog!: ElementRef<HTMLDialogElement>;
  public readonly storeUrl =
    PlatformService.getPlatform() === "ios" ? APP_STORE_URL : PLAY_STORE_URL;
  public readonly appVersion = environment.appVersion;

  public ngAfterViewInit(): void {
    this.dialog.nativeElement.showModal();
  }

  public ngOnDestroy(): void {
    this.dialog.nativeElement.close();
  }

  public onCancel(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.dismissIfOptional();
  }

  public dismissIfOptional(): void {
    if (!this.required) {
      this.dismiss.emit();
    }
  }
}
